// autopilot-cli-capabilities.ts
//
// V2 spec §7 "Pack ↔ CLI": the ONE source of the capability flags that
// `avatar autopilot capabilities --json` prints. startbuild probes these
// instead of comparing versions (SemVer orders `3.35.0-beta.N` below 3.35.0).
// A flag turns `true` in the SAME change that ships its handler, with a test
// tying the two together — never earlier:
//   init_deploy_target — init request `deploy_target` (phase 02, on)
//   decision_policy    — BLUEPRINT `decision_policy` + auto decisions (phase 03a, on:
//                        handler = supervisor-outcome-router-needs-decision-path.ts)
//   secrets_mount      — `test.env` + `run --release-secrets-stdin` (phase 04b, on:
//                        stdin reader + loader + recipe-env-source-merger + every
//                        redaction layer + I3 assert + E10 deny — B18, turned on last)
//   chat_drive         — lái mission từ chat Claude Code (phase 06k, on: run --detach/--json
//                        + last-run.json, status --wait + supervisor_alive, --delegated/--reason
//                        + source chat_delegated, Bảng G3 ủy nhiệm — turned on last)
export const AUTOPILOT_CLI_CAPABILITIES = Object.freeze({
  init_deploy_target: true,
  decision_policy: true,
  secrets_mount: true,
  chat_drive: true,
});

export type AutopilotCliCapabilities = typeof AUTOPILOT_CLI_CAPABILITIES;
